var Converter = require("./unitConversions.js");    

/*
 * Use as follows:
 * lib_core.types.enum(["", "μm", "mm", "in", "mil", "pt"]).validator
 */
var EnumType = function(values) {
    this.values = values;
    this.validator = this._validator.bind(this);
};
EnumType.prototype.parser = null;
EnumType.prototype._validator = function(val) {
    for(var i=0; i<this.values.length; i++) {
        if(this.values[i] == val)
            return true;
    }
    return false;
};

// this is the highest number we can correctly handle,
// because after this the parser starts using sci. notation
// and it results in problems when turning to string and sending to server.
var maxVal = 10000000000000000;

// PARSERS MAY RETURN NAN!!!
var floatParser = function(val){
    val = val.toString();
    // make sure its a number, trailing stuff at this point
    // is not ok (but parseFloat doesnt care)
    if(Converter.removeNumericalChars(val).trim() != "")
        return NaN;

    var num = parseFloat(val);
    if(num > maxVal) return NaN;
    if(num < -maxVal) return NaN;
    return num;
}
var positiveFloatParser = function(val){
    val = val.toString();
   // make sure its a number, trailing stuff at this point
    // is not ok (but parseFloat doesnt care)
    if(Converter.removeNumericalChars(val, true).trim() != "")
        return NaN;

    var num = parseFloat(val);
    if(num < 0) return NaN;
    if(num > maxVal) return NaN;
    return num;
}
var intParser = function(val){
    val = val.toString();
    // make sure its a number, trailing stuff at this point
    // is not ok (but parseFloat doesnt care)
    if(Converter.removeNumericalChars(val, false, true).trim() != "")
        return NaN;

    var num = parseInt(val);
    if(num > maxVal) return NaN;
    if(num < -maxVal) return NaN;
    return num;
}
var positiveIntParser = function(val){
    val = val.toString();
    // make sure its a number, trailing stuff at this point
    // is not ok (but parseFloat doesnt care)
    if(Converter.removeNumericalChars(val, true, true).trim() != "")
        return NaN;

    var num = parseInt(val);
    if(num < 0) return NaN;
    if(num > maxVal) return NaN;
    return num;
}


// READERS MAY RETURN NULL OR NAN

var floatReader = function(val, unit){
    if(unit){
        var outUnit = Converter.parseUnit(unit);

        var hasUnit = Converter.hasUnit(val);
        if(hasUnit){
            var inUnit = Converter.parseUnit(val);
            if(!inUnit) return null; // unrecognized unit
            val = Converter.trimUnit(val);
        }
    }

    val = floatParser(val);
    if(inUnit && outUnit && !isNaN(val)){
        val = Converter.convert(inUnit, outUnit, val);
    } 
    return val;
}

var positiveFloatReader = function(val, unit){
    if(unit){
        var outUnit = Converter.parseUnit(unit);

        var hasUnit = Converter.hasUnit(val);
        if(hasUnit){
            var inUnit = Converter.parseUnit(val);
            if(!inUnit) return null; // unrecognized unit
            val = Converter.trimUnit(val);
        }
    }

    val = positiveFloatParser(val);
    if(inUnit && outUnit && !isNaN(val)){
        val = Converter.convert(inUnit, outUnit, val);
    } 
    return val;
}

var intReader = function(val, unit){
    if(unit){
        var outUnit = Converter.parseUnit(unit);

        var hasUnit = Converter.hasUnit(val);
        if(hasUnit){
            var inUnit = Converter.parseUnit(val);
            if(!inUnit) return null; // unrecognized unit
            val = Converter.trimUnit(val);
        }
    }

    val = intParser(val);
    if(inUnit && outUnit && !isNaN(val)){
        val = Converter.convert(inUnit, outUnit, val);
    } 
    return val;
}

var positiveIntReader = function(val, unit){
    if(unit){
        var outUnit = Converter.parseUnit(unit);

        var hasUnit = Converter.hasUnit(val);
        if(hasUnit){
            var inUnit = Converter.parseUnit(val);
            if(!inUnit) return null; // unrecognized unit
            val = Converter.trimUnit(val);
        }
    }

    val = positiveIntParser(val);
    if(inUnit && outUnit && !isNaN(val)){
        val = Converter.convert(inUnit, outUnit, val);
    } 
    return val;
}

module.exports = {
    float: {
        name: "float",
        parser: floatParser,
        reader: floatReader,
        validator: function(value) {
            return typeof value == "number" && !isNaN(value);
        }
    },
    positive_float: {
        name: "positive_float",
        parser: positiveFloatParser,
        reader: positiveFloatReader,
        validator: function(value) {
            return typeof value == "number" && !isNaN(value) && value >= 0;
        }
    },
    int: {
        name: "int",
        parser: intParser,
        reader: intReader,
        validator: function(value) {
            return typeof value == "number" && Number.isInteger(value);
        }
    },
    positive_int: {
        name: "positive_int",
        parser: positiveIntParser,
        reader: positiveIntReader,
        validator: function(value) {
            return typeof value == "number" && Number.isInteger(value) && value >= 0;
        }
    },
    boolean: {
        name: "boolean",
        parser: function(val) {return !!val;},
        validator: function(val) {return typeof val == "boolean";}
    },
    string: {
        name: "string",
        parser: function(val) {return val.toString();},
        validator: function(val) {
            return typeof val == "string";
        }
    },
    object: {
        name: "object",
        parser: function(val) {return val;},
        validator: function(val) {return typeof val == "object";}
    },
    versioned_object: {
        name: "versioned_object",
        parser: function(val) {return val;},
        validator: function(val) {return typeof val == "object" && val.versions_id;}
    },
    any: {
        name: "any",
        parser: function(val) {return val;},
        validator: function() {return true;}
    },
    enum: function(values) {
        return new EnumType(values);
    }
};
